document.addEventListener('DOMContentLoaded', function() {
  // Get toggle buttons and size chart content sections
  const toggleBtns = document.querySelectorAll('.toggle-btn');
  const inchesContent = document.querySelector('.size-chart-inches');
  const cmContent = document.querySelector('.size-chart-cm');

  // Add event listeners to toggle buttons
  toggleBtns.forEach(button => {
    button.addEventListener('mouseenter', function() {
      // Remove 'active' class from all toggle buttons
      toggleBtns.forEach(btn => btn.classList.remove('active'));

      // Add 'active' class to the clicked button
      this.classList.add('active');

      // Toggle between inches and cm content based on data-unit attribute
      if (this.getAttribute('data-unit') === 'inches') {
        inchesContent.classList.add('active');
        cmContent.classList.remove('active');
      } else {
        inchesContent.classList.remove('active');
        cmContent.classList.add('active');
      }
    });
  });
});


